const downsizeCurrencySymbols = () => {
    const priceItems = document.querySelectorAll('.grid-product__price, .product-single__price, .cart__price, .cart__total__money, .cart-total-price , .cart__subtotal ');
    priceItems.forEach((priceItem) => {
        if (priceItem.classList.contains('downsized')) return;
        var originalText = priceItem.innerText;
        var newText = originalText.replace(/¥/g, '<span class="mini-symbol">¥</span>'); 
        priceItem.innerHTML = newText;
        priceItem.classList.add('downsized');
    });
}

window.addEventListener('DOMContentLoaded', (event) => {
    const observer = new MutationObserver(function() {
        observer.disconnect();
        downsizeCurrencySymbols(); 
        observer.observe(elem, config);
    });

    const config = {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
    };

    
        downsizeCurrencySymbols ();
});